import { render, staticRenderFns } from "./SyllabusEmptySubsection.vue?vue&type=template&id=e3731bb2&scoped=true&"
import script from "./SyllabusEmptySubsection.vue?vue&type=script&lang=js&"
export * from "./SyllabusEmptySubsection.vue?vue&type=script&lang=js&"
import style0 from "./SyllabusEmptySubsection.vue?vue&type=style&index=0&id=e3731bb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3731bb2",
  null
  
)

export default component.exports